import appStore from 'store';
import api from './api';
import { BILL_TYPE } from './constants';

const store = {
  namespaced: true,
  state: {
    coinTypeList: [],
    billTypes: [],
    activeTab: 'all',
    accountTypes: {},
    pagination: {
      page: 1,
      size: 25
    },
    bills: [],
    totalCount: 0
  },
  getters: {
    billList: state => {
      return state.bills.map(item => ({
        ...item,
        __type: BILL_TYPE[item.businessType]
      }));
    }
    // totalCount(state) {
    //   return state.bills && state.bills.length === state.pagination.size
    //     ? state.pagination.size * state.pagination.page + 1
    //     : state.pagination.size * state.pagination.page;
    // }
  },
  mutations: {
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setBillTypeList(state, payload) {
      state.billTypes = payload;
    },
    setAccountType(state, payload) {
      state.accountTypes =
        payload &&
        Object.keys(payload).reduce(
          (obj, key) => ({
            ...obj,
            [payload[key]]: key.replace(/(.*)?_([^_]+_[^_]+)$/, '$2')
          }),
          {}
        );
    },
    setBillList(state, payload) {
      state.bills = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    }
  },
  actions: {
    listCoinType({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    listAccountType({ commit }) {
      api.getAccountType().then(({ data }) => {
        commit('setAccountType', data);
      });
    },
    listBillType({ commit }) {
      api.getBillTypeList().then(({ data }) => {
        commit('setBillTypeList', data);
      });
    },
    reqBills({ commit }, query) {
      api.reqBills(query).then(({ data }) => {
        commit('setBillList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    }
  }
};

appStore.registerModule('userBill', store);
